import { render } from "./feedback-footer.vue?vue&type=template&id=6b639e44&scoped=true"
const script = {}

import "./feedback-footer.vue?vue&type=style&index=0&id=6b639e44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b639e44"]])

export default __exports__